import { Platform } from 'react-native'
import WebView from 'react-native-webview'

type keyValuePair = {
  [key: string]: any
}

type UniversalWebViewProps = {
  iframeProps: keyValuePair
  webviewProps: keyValuePair
}

const UniversalWebView = ({
  iframeProps,
  webviewProps
}: UniversalWebViewProps) => {
  if (Platform.OS === 'web') {
    return <iframe {...iframeProps} />
  }

  return <WebView {...webviewProps} />
}

export default UniversalWebView
